exports.ByName = {
  None: { Id: 0, Name: 'None', Value: 'usa_method_evaluations.none' },
  Best: { Id: 1, Name: 'Best', Value: 'usa_method_evaluations.best' },
  Supporting: { Id: 2, Name: 'Supporting', Value: 'usa_method_evaluations.supporting' },
  Exclude: { Id: 3, Name: 'Exclude', Value: 'usa_method_evaluations.exclude' }
};

exports.ById = {
  0: { Id: 0, Name: 'None', Value: 'usa_method_evaluations.none' },
  1: { Id: 1, Name: 'Best', Value: 'usa_method_evaluations.best' },
  2: { Id: 2, Name: 'Supporting', Value: 'usa_method_evaluations.supporting' },
  3: { Id: 3, Name: 'Exclude', Value: 'usa_method_evaluations.exclude' }
};

exports.AsOrderedArray = [
  { Id: 0, Name: 'None', Value: 'usa_method_evaluations.none' },
  { Id: 1, Name: 'Best', Value: 'usa_method_evaluations.best' },
  { Id: 2, Name: 'Supporting', Value: 'usa_method_evaluations.supporting' },
  { Id: 3, Name: 'Exclude', Value: 'usa_method_evaluations.exclude' }
];
